function fadeInRight(duration = 0.3) {
  return {
    from: {
      right: '-100%',
      transition: {
        type: 'easeInOut',
        duration,
      },
    },
    to: {
      right: 0,
      transition: {
        type: 'easeInOut',
        duration,
      },
    },
  };
}

export default fadeInRight;
